import React from 'react';
import { DatePicker } from 'antd';
import moment from 'moment';

type Props = {
  value: string | null,
  onChange: (value: string) => void,
  onBlur: () => void,
};

export default function DateInput(props: Props) {
  const { value, onBlur, onChange, placeholder } = props;
  return (
    <DatePicker
      placeholder={placeholder}
      style={{ width: '100%' }}
      value={value ? moment(value) : null}
      onBlur={onBlur}
      onChange={newValue => {
        if (newValue) {
          onChange(newValue.format('YYYY-MM-DD'));
        } else {
          onChange(null);
        }
      }}
    />
  );
}
